/**
 * number with commas
 * @param  {*}
 * @return {String}
 */
__.numberWithCommas = function(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
